import { i18n } from '@lingui/core';
import { styled, ThemeProvider } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';
import { BrowserRouter } from 'react-router-dom';
import { Auth0ProviderWithNavigate } from './app/Auth0ProviderWithNavigate';
import { GraphQlProvider } from './app/GraphQlProvider';
import { AppRoutes } from './AppRoutes';
import { CountryProvider } from './contexts/CountryProvider';
import { theme } from './customTheme';
import { I18nProvider } from '@lingui/react';

const Snackbar = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent': {
    fontSize: '2rem',
    lineHeight: '3rem',
  },
}));

export const AppProviders = () => {
  return (
    <SnackbarProvider maxSnack={3} Components={{ success: Snackbar, error: Snackbar }}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Auth0ProviderWithNavigate>
            <GraphQlProvider>
              <CountryProvider>
                <I18nProvider i18n={i18n}>
                  <AppRoutes />
                </I18nProvider>
              </CountryProvider>
            </GraphQlProvider>
          </Auth0ProviderWithNavigate>
        </BrowserRouter>
      </ThemeProvider>
    </SnackbarProvider>
  );
};
